import { track } from "@vercel/analytics";

/**
 * Coarse, non-identifying custom events for Vercel Web Analytics.
 * Never pass curated destination URLs, emails, or other free-form PII.
 */
export function trackEvent(
  name: string,
  properties?: Record<string, string | number | boolean | null | undefined>
): void {
  try {
    track(name, properties);
  } catch {
    /* ignore */
  }
}
